
  <mat-card class="speech-bubble" style="padding: 0;">
    <table style="width: 100%; height: 100%; padding: 0px; margin: 0px">
      <tr>
        <td class="upperTd"  >
          <div class="maherlogo" (click)="myApp.showCharts()"></div>
          <div class="titleFont" style="padding-bottom: 3px; text-align: center; padding-top: 10px">User Entry</div>
          <table style="min-width: 100%; max-width: 100%">
            <tr>
              <td style="max-width: 50%; min-width: 50%; text-align: right">
                <mat-form-field appearance="outline"   style="width: 80%; padding: 0px;" >
                  <mat-label >Username</mat-label>
                  <input maxlength="30"   [(ngModel)]="userName" matInput oninput="this.value = this.value.toUpperCase()" [disabled]="submitted"/>
                </mat-form-field>
              </td>
              <td style="max-width: 50%; min-width: 50%; text-align: left; ">
                <a  matTooltip="check password"  style="font-size: 13px; cursor: pointer; padding-top: 6px">
                  <button mat-raised-button class="blueButton"  (click)="getUsername()" style="width: 8%;height: 47px; vertical-align: super;" color="primary" [disabled]="submitted"><img style="height: 33px" src="assets/search.png" ></button>
                </a>
              </td>
            </tr>
          </table>



          <div class="errorDiv2"  *ngIf="didntEnterShit">Username required</div>
          <div class="errorDiv2"  *ngIf="badChars">Special Characters Not Allowed</div>
          <div class="errorDiv2"  *ngIf="maherErrorFound">{{errorOut}}</div>
          <div style="border-bottom: #E61E00 1px solid; padding-top: 5px"></div>


          <div style="background-color: rgba(238,238,237,0.7); height: 100%">

          <div class="smallerFont" style="text-align: center; padding-bottom: 15px; padding-top: 5px">All Fields Marked With <mat-icon matSuffix><img style="vertical-align: center;" src="assets/check_circle-24px.svg" ></mat-icon> Are Required Fields</div>




          <form  [formGroup]="myForm" autocomplete="off"   novalidate>

            <div class="two-col">
              <div class="col1">
                <mat-form-field appearance="outline" style="width: 90%; " >
                  <mat-label>First Name</mat-label>
                  <input maxlength="30"  matInput formControlName="firstName" />
                  <mat-icon matSuffix *ngIf="f.firstName.errors && submitted && !inquiryMode"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.firstName.errors && submitted && !inquiryMode"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.firstName.errors" class="invalid-feedback" >
                     <div class="errorDiv2"  *ngIf="f.firstName.errors.required && saveHit">First Name Required</div>
                </span>
              </div>
              <div class="col2">
                <mat-form-field appearance="outline" style="width: 90%;">
                  <mat-label>Last Name</mat-label>
                  <input maxlength="30"  matInput formControlName="lastName" />
                  <mat-icon matSuffix *ngIf="f.lastName.errors && submitted && !inquiryMode"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.lastName.errors && submitted && !inquiryMode"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.lastName.errors" class="invalid-feedback" >
                  <div class="errorDiv2"  *ngIf="f.lastName.errors.required && saveHit">Last Name Required</div>
                </span>
              </div>
            </div>


            <div class="two-col">
              <div class="col1">
                <mat-form-field appearance="outline" style="width: 90%;">
                  <mat-label>Email Address</mat-label>
                  <input maxlength="50"  matInput formControlName="email" />
                  <mat-icon matSuffix *ngIf="f.email.errors && submitted && !inquiryMode"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.email.errors && submitted && !inquiryMode"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.email.errors" class="invalid-feedback">
                  <div class="errorDiv2"  *ngIf="f.email.errors.required && saveHit">Email Address Required</div>
                </span>
              </div>
              <div class="col2">
                <mat-form-field appearance="outline" style="width: 90%;">
                  <mat-label>Phone Number: (999) 999-9999</mat-label>

                  <input matInput id="tel" phoneMask [preValue]="myForm.value.phone"  [phoneControl]="myForm.controls['phone']" formControlName="phone" maxlength="14"  />
                  <mat-icon matSuffix *ngIf="f.phone.errors && submitted && !inquiryMode"><img style="vertical-align: center; padding-bottom: 3px;" src="assets/check_circle-24px.svg" ></mat-icon>
                  <mat-icon matSuffix *ngIf="!f.phone.errors && submitted && !inquiryMode"><img style="vertical-align: center; height: 20px; width: 20px; margin-bottom: 5px; margin-left: 2px" src="assets/greenCheck.png" ></mat-icon>
                </mat-form-field>
                <span *ngIf="f.phone.errors" class="invalid-feedback">
                  <div class="errorDiv2"  *ngIf="f.phone.errors.required && saveHit">Phone Number Required</div>
                </span>
              </div>
            </div>


            <div class="two-col">
              <div class="col1">
                <mat-form-field class="myOption2"  appearance="outline">
                  <mat-label>Active User</mat-label>
                  <mat-select  [(value)]="activeAccount"  [disabled]="!submitted">
                    <mat-option  *ngFor="let lr of options" [value]="lr.code">{{lr.description}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

          </form>
          </div>

        <div *ngIf="showThePasswords">
          <form  [formGroup]="myForm2" autocomplete="off"   novalidate>
            <table style="width: 100%; padding: 0px; margin: 0px; padding-left: 19px ">
                <tr >
                  <td style="text-align: left; width: 46%; " >

                    <mat-form-field appearance="outline" style="width: 100%"   >
                      <mat-label >Password</mat-label>
                      <input maxlength="20"   (keyup)="checkRules()"  [type]="activePass ? 'password' : 'text'" matInput formControlName="password"/>
                      <div matSuffix matTooltip="show/hide password" (click)="showPassword()"  style="font-size: 13px;cursor: pointer; " >
                        <a *ngIf="activePass" >SHOW </a>
                        <a *ngIf="!activePass">HIDE </a>
                      </div>

                    </mat-form-field>
                    <span *ngIf="g.password.errors" class="invalid-feedback" style="text-align: center">
                  <div class="errorDiv2"  *ngIf="g.password.errors.required && saveHit">Both Password/Confirm Password Are Required</div>
                </span>
                    <mat-form-field appearance="outline" style="width: 100%" >
                      <mat-label  >Confirm Password</mat-label>
                      <input maxlength="20" [type]="activeConfirm ? 'password' : 'text'" matInput formControlName="confirm"/>
                      <div matSuffix matTooltip="show/hide password" (click)="showConfirmPassword()"  style="font-size: 13px;cursor: pointer">
                        <a *ngIf="activeConfirm ">SHOW </a>
                        <a *ngIf="!activeConfirm ">HIDE </a>
                      </div>
                    </mat-form-field>
                    <div class="errorDiv2" style="font-size: 14px" *ngIf="disableSubmit && submitted">Confirm Password Doesn't Match</div>

                  </td>
                  <td style="text-align: -webkit-center; text-align: -moz-center;vertical-align: bottom; padding-left: 29px">
                    <div style="background-color:#efefef;text-align: left; padding-top: 15px; width: 100%">
                      <div style="font-weight: bolder; font-size: 16px; text-align: center">Your password must contain at least:</div>
                      <div style="font-weight: lighter; font-size: 14px; padding-left: 80px"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="totalFound>5 ? 'assets/greenCheck.png': 'assets/troubleRed.png'"  ></mat-icon>5 or more Characters</div>
                      <div style="font-weight: lighter; font-size: 14px; padding-left: 80px"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="lowerFound>2 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>3 Lowercase letters</div>
                      <div style="font-weight: lighter; font-size: 14px; padding-left: 80px"><mat-icon matPrefix ><img style="vertical-align: center; height: 17px" [src]="numberFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Number</div>
                      <div style="font-weight: lighter; font-size: 14px; padding-left: 80px; padding-bottom: 11px"><mat-icon matPrefix ><img style="vertical-align: center;height: 17px" [src]="strangeFound>0 ? 'assets/greenCheck.png': 'assets/troubleRed.png'" ></mat-icon>1 Special Character</div>
                    </div>

                  </td>

                </tr>
            </table>
            <div class="errorDiv2" style="font-size: 14px" *ngIf="todo.length==0">Must Assign At Least 1 Role</div>

          </form>
        </div>

          <div style="background-color: rgba(23,122,241,0.07); height: 100%">

          <table style="width: 100%; padding: 0px; margin: 0px; padding-left: 19px ">
            <tr>
              <td style="width: 48%;  vertical-align:top; text-align: -webkit-right">
                <table class="example-element-diagram2">
                  <td class="example-element-description4">
                    <div style="background-color: #E61E00; color: white; padding: 5px;font-size: 15px; min-width: 300px; text-align: center">Available Roles</div>
                    <div class="example-container">
                      <div
                        cdkDropList
                        #doneList="cdkDropList"
                        cdk-scrollable style="height:200px;  overflow-y:scroll"
                        [cdkDropListData]="done"
                        [cdkDropListConnectedTo]="[todoList]"
                        class="example-list"
                        (cdkDropListDropped)="drop($event)">
                        <div class="example-box" *ngFor="let item of done" cdkDrag>
                          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>{{item}}</div>
                      </div>
                    </div>
                  </td>
                </table>
              </td>
              <td style="width: 1%;"></td>
              <td style="width: 48%; vertical-align:top;">
                <table class="example-element-diagram2">
                  <tr>
                    <td class="example-element-description4">
                      <div style="background-color: #E61E00; color: white; padding: 5px;font-size: 15px; min-width: 300px; text-align: center">Assigned Roles</div>
                      <div class="example-container">
                        <div
                          cdkDropList
                          cdk-scrollable style="height:200px;  overflow-y:scroll"
                          #todoList="cdkDropList"
                          [cdkDropListData]="todo"
                          [cdkDropListConnectedTo]="[doneList]"
                          class="example-list"
                          (cdkDropListDropped)="drop($event)">
                          <div class="example-box" *ngFor="let item of todo" cdkDrag>{{item}}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>

              </td>
            </tr>
            <tr>
              <td colspan="3">
                <div style="; text-align: center; padding-top: 10px">
                  <button mat-raised-button class="blueButton" style="min-width: 100px"  (click)="saveSubUser()"  color="primary" [disabled]="!submitted" >Save User</button>
                  <a style="padding-left: 20px"></a>
                  <button mat-raised-button class="redButton" style="min-width: 100px"  (click)="cancelScreen()"  color="primary" >Cancel</button>
                </div>
              </td>
            </tr>
          </table>

          </div>

        </td>

        <td class="loginPic" style="width: 10%;  height: 100%;  vertical-align: top;">
        </td>
      </tr>
    </table>
  </mat-card>
